// extracted by mini-css-extract-plugin
module.exports = {"blurAwareContainer":"BlurAwareContainer_blurAwareContainer__2BwAg","fullWidth":"BlurAwareContainer_fullWidth__diRiy"};